import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


// Components

import Form from '../../../lib/wrappers/Form';
import PageHeader from '../headers/PageHeader';
import UniversalInput from '../../../lib/wrappers/UniversalInput';

// ActionCreators

import { changeData } from '../../../actions/ssap/ssapActionCreators';

// Utils

import { householdMemberTools } from '../../../utils/tools/householdMemberTools';
import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';

// Constants

import { INPUT_TYPES } from '../../../constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '../../../constants/inputs/validationTypes';
import { DROPDOWN_OPTIONS } from '../../../constants/ssap/hhmTypes/dropdownOptions';


/**
 *
 * @param {Object} props
 * @returns {React.Component} - 'Applicants' Page
 *
 */
const Page1_04 = props => {

    const {
        data,
        data: {
            applyingForhouseHold,
            taxHousehold: {
                householdMember: householdMembers
            }
        },
        formName,
    } = props;

    const {
        name
    } = householdMemberTools.getPrimaryContact(householdMembers);

    /**
     *
     * @param {Object} newData - updated <singleStreamlinedApplication> object
     *
     * Updating <applyingForhouseHold> props in JSON
     */
    const onFieldChange = newData => {
        props.actions.changeData({
            ...newData
        });
    };

    return (
        <Fragment>
            <div id="saPrimaryContact" className="">
                <div className="subsection">
                    <PageHeader
                        text='ssap.subheader.who_needs_health_insurance'
                        headerClassName={'gi-heading-alt'}
                    />
                    <Form { ...{ formName } }>
                        <UniversalInput
                            legend={{
                                legendText: 'ssap.input.legend.select_one_below'
                            }}
                            label={{
                                labelClass: ['grid-row', 'padding-tb-0'],
                                showRequiredIcon: true
                            }}
                            inputData={{
                                isInputRequired: true,
                                type: INPUT_TYPES.RADIO_BUTTONS,
                                name: 'applyingForhouseHold',
                                value: applyingForhouseHold,
                                options: DROPDOWN_OPTIONS.COVERAGE,
                                optionsReplacements: { personName: normalizeNameOfPerson(name) },
                                validationType: VALIDATION_TYPES.CHOSEN,
                                currentData: data,
                                fields: []
                            }}
                            errorClasses={['margin-l-0 margin-b-10']}
                            inputActions={{
                                onFieldChange
                            }}
                        />
                    </Form>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page1_04);
